import React, { useCallback } from 'react';

import { format } from 'date-fns';
import { showModal } from 'modal.react.js';
import { useDispatch } from 'react-redux';

import area from 'components/shared/GlobalModalArea/area';
import { updateStartDateAction } from 'store/itinerariesItem';
import { getLocalDateFromString } from 'utils/date';

import { IUpdateStartDateProps } from './types';

import { UpdateStartDateModal } from './index';

export async function updateStartDate(date: IUpdateStartDateProps['date']) {
  await showModal(area, (res) => <UpdateStartDateModal res={res} date={date} />);
}

export function useUpdateStartDate({ res, date }: IUpdateStartDateProps) {
  const dispatch = useDispatch();

  const handleUpdate = useCallback(() => {
    dispatch(updateStartDateAction(date.start));
    res();
  }, [res, date, dispatch]);

  const newDate = format(getLocalDateFromString(date.start), 'MMMM d, yyyy');

  const config = {
    headerText: 'Heads up!',
    bodyText: (
      <>
        Are you sure you want to update the Start Date for this itinerary? <br />
        All subsequent dates will be updated with a new start date of <strong>{newDate}</strong>
      </>
    ),
    onAccept: handleUpdate,
    closeButtonText: 'Back',
    confirmButtonText: 'Confirm',
  };

  return { config };
}
